export const orderDetailFragment = {
  id: true,
  documentNumber: true,
  status: true,
  account: {
    id: true,
    name: true,
    addresses: {
      id: true,
      address: {
        __scalar: true,
      },
    },
  },
  lineItems: {
    id: true,
  },
};
